import { DataBean } from "../DataBean";

export class ImportContracts  extends DataBean {


    public async getImportContractsCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "java.util.List_getImportContractsCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }


 
}